import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index.js"

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location, onComplete, onAbort) {
    if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
        return originalPush.call(this, location, onComplete, onAbort).catch(err => { })
    } else {
    	// <router-link>进行路由跳转时，传了一个oncomplate方法
        originalPush.call(this, location, onComplete, onAbort)
    }
}



Vue.use(VueRouter)

const routes = [
	{
		path: '',
		redirect:'/pc/home'
	},
	{
		path: '/pc/home',
		name: 'home',
		component: () => import('../views/pc/home/Home.vue')
	},
	{
		path: '/pc/brand',
		name: 'brand',
		component: () => import('../views/pc/brand/Brand.vue')
	},
	{
		path: '/pc/verify',
		name: 'Verify',
		component: () => import('../views/pc/verify/Verify.vue')
	},
	{
		path: '/pc/category',
		name: 'category',
		component: () => import('../views/pc/category/Category.vue'),
		children: [{
				path: '',
				component: () => import('../views/pc/category/index.vue'),
			},
			{
				path: 'detail/:id',
				component: () => import('../views/pc/category/detail.vue'),
			}
		]
	},
	{
		path: '/app/home',
		name: 'home',
		component: () => import('../views/app/home/Home.vue')
	},
	{
		path: '/app/brand',
		name: 'brand',
		component: () => import('../views/app/brand/Brand.vue')
	},
	{
		path: '/app/verify',
		name: 'Verify',
		component: () => import('../views/app/verify/Verify.vue')
	},
	{
		path: '/app/category',
		name: 'category',
		component: () => import('../views/app/category/Category.vue'),
		children: [{
				path: '',
				component: () => import('../views/app/category/index.vue'),
			},
			{
				path: 'detail/:id',
				component: () => import('../views/app/category/detail.vue'),
			}
		]
	}
]

const router = new VueRouter({
	routes,
	mode:"history",
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			window.scroll(0,0)
			return {
				top: 0
			}
		}
	},
})
router.beforeEach((to, from, next) => {
	let isMobile = store.state.isMobile
	if (isMobile) {
		if (to.path.indexOf('/app') >= 0) {
			next()
		} else {
			next('/app' + to.path.replace('/pc', ''))
		}

	} else {

		if (to.path.indexOf('/pc') >= 0) {
			next()
		} else {
			next('/pc' + to.path.replace('/app', ''))
		}
	}
})
export default router
